import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { SEARCH_HINTS } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { SearchType } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { MissingProgrammingRecordsFieldName } from '../missing-programming-records.types';

export const MISSING_PROGRAMMING_RECORDS_SEARCH_TYPES: SearchType[] = [
  {
    text: TranslateRegistry.get.SEARCH.TYPE.COMM_DEVICE_ID,
    value: 1,
    types: [MissingProgrammingRecordsFieldName.CommDeviceId],
    hintText: SEARCH_HINTS.Search
  }
];

export const MISSING_PROGRAMMING_RECORDS_DEFAULT_SEARCH_TYPE: SearchType = MISSING_PROGRAMMING_RECORDS_SEARCH_TYPES[0];
